import { graphql } from '@/gql';
// import type { FetchSmsTemplatesQuery, FetchSmsTemplatesQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { PaginatedUserTypeResponse } from '@/models/user';

export const getUsersWithForms = async ({
  searchType,
  searchValue,
  onlyUnsignedUserForms,
  pagination,
}: any): Promise<PaginatedUserTypeResponse> => {
  const response = await queryExecute({
    query: graphql(`
      query GetUsersWithForms(
        $searchType: String!
        $searchValue: String!
        $onlyUnsignedUserForms: Boolean
        $pagination: PaginationInputType
      ) {
        usersWithForms(
          searchType: $searchType
          searchValue: $searchValue
          onlyUnsignedUserForms: $onlyUnsignedUserForms
          pagination: $pagination
        ) {
          count
          rows {
            id
            firstName
            lastName
            email
            roles
            userForms {
              id
              formId
              fileName
              fileKey
              uploadedAt
              form {
                id
                name
                description
                url
                createdAt
              }
            }
          }
        }
      }
    `),
    variables: {
      searchType,
      searchValue,
      onlyUnsignedUserForms,
      pagination,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.usersWithForms!;
};
